import SelectDinamico from "../../SelectDinamico";
import ConsultaTipoFornecimento from "../../../../lib/json/consultas/TipoFornecimento.json"

function SelectTipoFornecimento({campoTipoFornecimento, changeTipoFornecimento, queryTipoFornecimento, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, showNoFilter=false}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const cConsultaDefault = ConsultaTipoFornecimento.consulta;
    
    const consulta = queryTipoFornecimento || ( loadDefault ? cConsultaDefault : '' )
    const TipoFornecimentoValue = bindItem ? bindItem[field] : campoTipoFornecimento;

    return (
        <SelectDinamico
            label="Tipo de Fornecimento"
            cText="PSV_CODIGO + ' - ' + item.PSV_DESCRI"
            cValue="PSV_CODIGO"
            campoValue={TipoFornecimentoValue}
            consulta={consulta}
            tabela={ConsultaTipoFornecimento.tabelas}
            isMultiplo={false}
            showNoFilter={showNoFilter}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeTipoFornecimento(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectTipoFornecimento;